var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._g(_vm._b({attrs:{"disabled":!_vm.temSomenteUmMenuPermitido,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","disabled":_vm.mostrarContagem},on:{"click":function () { return !_vm.temSomenteUmMenuPermitido
				? _vm.mostraNavBar = !_vm.mostraNavBar
				: _vm.UserLoginStore.logout(); }}},'v-btn',attrs,false),on),[(_vm.temSomenteUmMenuPermitido)?_c('v-icon',[_vm._v(" mdi-logout ")]):_c('v-icon',[_vm._v(" mdi-menu ")])],1)]}}])},'v-tooltip',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v("Sair")])])}
var staticRenderFns = []

export { render, staticRenderFns }